// Swiper

var ttSwiper = {
  init: function () {
    var s = this;

    $('.ttswiper').each(function (index) {
      var th = $(this);
      var swiper_el = th.find('.swiper');
      var slide_num = th.find('.swiper-slide').length;
      
      // if (slide_num == 1 && !th.is('.autowidth')) {
      if (slide_num == 1) {
        th.find('.swiper-nav').remove();
        th.addClass('swiper_init');
      }

      if (th.is('.swiper_init')) return;
      th.attr('id', 'swiper-' + index);

      var _autoplay = th.data('autoplay') || 0;
      var _speed = th.data('speed') || 800;
      var _direction = th.is('.swiper-v') ? 'vertical' : 'horizontal';
      var _loop = th.is('.swiper-loop');
      var _grab = th.is('.swiper-grab');
      var _perview = th.is('.autowidth') ? 'auto' : 1;
      var _wheel = th.is('.swiper-wheel');
      var _freemode = th.is('.swiper-freemode');
      var _autoheight = th.is('.autoheight') || false;
      var _spaceBetween = th.data('space') || 0;
      var _initslide = th.data('initslide') || 0;
      var _clickto = th.is('.swiper-clickto') ? true : false;
      var _center = false;
      // var save_id = 0;

      // if (is_localhost) _autoplay = 0;

      var is_autowidth = th.is('.autowidth');

      // if (th.is('.autowidth.cols-3')) _perview = 3;

      var is_imginfo_swiper = th.is('.imginfo-swiper');
      if (is_imginfo_swiper) {
        _perview = 'auto';
        th.find('.group-title[data-pos="1"]').removeClass('hide');
      }

      var is_tt_loop_swiper = th.is('.tt_loop_swiper');
      if (is_tt_loop_swiper) {
        _perview = 'auto';
        _center = true;
        _loop = true;
        _speed = 800;
        _autoplay = 5000;
        th.addClass('autoplaying');
      }
      
      var swiper_thumbs = 0;
      var is_pdc_photos = th.is('.pdc-head-photos .photos');

      if (is_pdc_photos) {
        swiper_thumbs = {
          swiper: {
            el: '.pdc-head-photos .swiper-thumbs',
            slidesPerView: 'auto',
            watchSlidesVisibility: true,
            breakpointsBase: 'window'
          },
          autoScrollOffset: 1
        }
      }


      var swiper_obj = new Swiper(swiper_el[0], {
        pagination: {
          el: th.find('.swiper-pagination')[0],
          clickable: true
        },
        navigation: {
          nextEl: th.find('.btn-next')[0],
          prevEl: th.find('.btn-prev')[0]
        },
        uniqueNavElements: false, //当存在多个同名导航元素时，设置导航元素是否唯一
        watchOverflow: true, //仅有 1 个 slide 时，swiper 无效

        direction: _direction,

        autoplay: _autoplay > 0 ? {
          delay: _autoplay,
          disableOnInteraction: true
        } : false,

        centeredSlides: _center,
        loop: _loop,
        // loopAdditionalSlides: 1,
        speed: _speed,
        spaceBetween: _spaceBetween,
        initialSlide: _initslide,
        // grabCursor: _grab,
        longSwipesRatio: 0.3,
        slidesPerView: _perview,
        // slidesPerGroupAuto: is_autowidth ? true : false, //自动分组。只有同时满足 slidesPerView: 'auto'和 slidesPerGroup: 1 才有效
        normalizeSlideIndex: is_autowidth ? false : true, // auto 时关闭标准化的 Slide 索引
        threshold: 20, //拖动的临界值（单位为px），如果触摸距离小于该值滑块不会被拖动
        runCallbacksOnInit: is_tt_loop_swiper ? true : false, //如果不想触发初始化时 [Transition/SlideChange] [Start/End] 回调函数，将此设置为 false
        autoHeight: _autoheight,
        // preloadImages: false,
        parallax: true,
        observer: true,
        // watchSlidesVisibility: is_pdc_thumbs ? true : false,
        // watchSlidesProgress : true,
        mousewheelControl: _wheel,
        freeMode: _freemode,
        slideToClickedSlide: _clickto,
        // lazyLoading : true,
        // lazyLoadingInPrevNext : true,
        edgeSwipeDetection: true,

        thumbs: swiper_thumbs,

        on: {
          init: function () {
            // th.find('.swiper-slide:not(.swiper-slide-active) .anim_emt').addClass('in');
            if (is_pdc_photos) {
              var thumb_el = $('.pdc-head-photos .photo-thumbs .swiper-slide');
              thumb_el.removeClass('swiper-slide-thumb-active swiper-slide-active');
              thumb_el.eq(this.activeIndex).addClass('swiper-slide-thumb-active swiper-slide-active');
            }
          },

          autoplayStart: function () {
            th.addClass('autoplaying');
          },

          autoplayStop: function () {
            th.removeClass('autoplaying');
          },
          
          touchEnd: function (swiper, event) {
            if (is_tt_loop_swiper && !this.autoplay.running)
              this.slides.transition(this.params.speed).transform('translate3d(0, 0, 0)');
          },

          slideChangeTransitionStart: function () {
            if (is_tt_loop_swiper && th.is('.autoplaying')) {
              var trans_x = $(window).width() > 1200 ? '30px' : '0px';
              this.slides.transition(this.params.speed).transform('translate3d(' + trans_x + ', 0, 0)');
            }
          },

          slideChangeTransitionEnd: function () {
            if (is_tt_loop_swiper) {
              if (th.is('.autoplaying')) {
                var trans_x = $(window).width() > 1200 ? '-30px' : '-30px';
                this.slides.transition(this.params.autoplay.delay + this.params.speed).transform('translate3d(' + trans_x + ', 0, 0)');
              } else {
                this.slides.transition(this.params.speed).transform('translate3d(0, 0, 0)');
              }
            }
          },
          
          slideChange: function () {
            var active_id = this.activeIndex;
  
            if (is_imginfo_swiper) {
              var title_el = th.find('.group-title');
  
              if (title_el.length) {
                title_el.each(function (i) {
                  var th = $(this);
                  var th_id = Math.round(th.data('pos'));
                  var next_id = Math.round(title_el.eq(i + 1).data('pos'));
                  if (i + 1 == title_el.length) next_id = 100;
                  if (active_id + 1 >= th_id && active_id + 1 < next_id) {
                    if (th.is('.hide')) {
                      th.removeClass('hide').data('timer', 0);
                      animElements.anim_start(th);
                    }
                  } else {
                    th.addClass('hide').removeClass('in visb');
                  }
                });
              }
            }
          }
        }
      });

      th.addClass('swiper_init');
      th.attr('data-swiperid', index);
      window['swiper_' + index] = swiper_obj;

      var sameheight_position = function () {
        var wrap_el = th.find('.swiper-wrapper');
        var nav_el = th.find('.swiper-nav');
        var window_w = $(window).width();
        var main_cont_w = nav_el.innerWidth();
        var wrap_h = wrap_el.innerHeight();
        var slides_w = 0;

        th.find('.swiper-slide').each(function () {
          var img_dw = $(this).find('.img').data('pswp-width');
          var img_dh = $(this).find('.img').data('pswp-height');
          var img_w = wrap_h * (img_dw / img_dh);
          // console.log(img_w);
          slides_w += img_w + parseInt($(this).css('margin-right'));
        });

        // console.log(slides_w);
        wrap_el.removeClass('container flex-centerh');
        if (slides_w <= window_w && slides_w >= main_cont_w) {
          wrap_el.addClass('flex-centerh').css('cursor', 'auto');
          nav_el.addClass('hide');
        }
        if (slides_w < main_cont_w) {
          wrap_el.addClass('container').css('cursor', 'auto');
          nav_el.addClass('hide');
        }
        if (slides_w > window_w) {
          if(_grab) wrap_el.css('cursor', 'grab');
          nav_el.removeClass('hide');
        }
      }

      if (th.is('.sameheight')) {
        sameheight_position();
        $(window).off('resize.sameheight').on('resize.sameheight', sameheight_position);
      }
    });
  }

}